"use client";

import { c as _c } from "react/compiler-runtime";
import cn from "classnames";
import { useMemo, useState } from "react";
import { ChecklistCard } from "./ChecklistCard";
import { Icons } from "./ChecklistIcons";
import { CHECKLISTS_DATA } from "./constants";
export const ChecklistPage = () => {
  const $ = _c(16);
  const [activeId, setActiveId] = useState("pistolet-zakup-checklist");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [checkedItems, setCheckedItems] = useState(t0);
  let t1;
  if ($[1] !== activeId) {
    t1 = CHECKLISTS_DATA.find(d => d.id === activeId) || CHECKLISTS_DATA[0];
    $[1] = activeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentData = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (listId, itemIndex) => {
      setCheckedItems(prev => {
        const listChecked = prev[listId] || [];
        const newListChecked = listChecked.includes(itemIndex) ? listChecked.filter(i => i !== itemIndex) : [...listChecked, itemIndex];
        return {
          ...prev,
          [listId]: newListChecked
        };
      });
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleItem = t2;
  const handlePrint = _temp;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <style>{"\n        @media print {\n          @page {\n            margin: 0.8cm;\n            size: A4;\n          }\n          .no-print {\n            display: none !important;\n          }\n          body {\n            background: white !important;\n            color: black !important;\n            font-size: 9pt !important;\n          }\n          .checklist-card {\n            border: none !important;\n            box-shadow: none !important;\n            background: white !important;\n            width: 100% !important;\n            padding: 0 !important;\n          }\n          .fase-items-grid {\n            display: grid !important;\n            grid-template-columns: 1fr 1fr !important;\n            gap: 6px !important;\n          }\n          .checklist-item-box {\n            padding: 4px 8px !important;\n            border: 1px solid #e2e8f0 !important;\n            background: #f8fafc !important;\n            color: black !important;\n            break-inside: avoid;\n          }\n          .checklist-item-box span {\n            color: black !important;\n            opacity: 1 !important;\n          }\n          h1,\n          h2 {\n            font-size: 16pt !important;\n          }\n          h3 {\n            font-size: 11pt !important;\n            margin-bottom: 4px !important;\n            margin-top: 10px !important;\n          }\n          .verdict-container {\n            display: grid !important;\n            grid-template-columns: 1fr 1fr !important;\n            gap: 10px !important;\n            margin-top: 10px !important;\n            padding-top: 10px !important;\n          }\n          .description-text {\n            display: none !important;\n          }\n          .marketing-footer {\n            margin-top: 10px !important;\n            font-size: 8pt !important;\n            color: #64748b !important;\n          }\n          .card-padding {\n            padding: 0 !important;\n          }\n          .section-gap {\n            margin-bottom: 12px !important;\n          }\n          .print-only {\n            display: block !important;\n          }\n        }\n        .print-only {\n          display: none;\n        }\n      "}</style>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <header className="text-center mb-6 no-print animate-fade-in"><div className="inline-flex items-center gap-2 mb-2"><div className="w-10 h-10 bg-brand-500 rounded-lg flex items-center justify-center text-white shadow-lg"><Icons.Target className="w-6 h-6" /></div><h1 className="text-xl md:text-3xl font-black uppercase tracking-tighter text-slate-900 dark:text-slate-100">Tarcza Kupującego</h1></div><p className="text-slate-500 text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold">Protokół Inspekcji Broni</p></header>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeId) {
    t5 = CHECKLISTS_DATA.map(list => <button key={list.id} onClick={() => setActiveId(list.id)} className={cn("flex items-center gap-1.5 px-4 py-2 rounded-lg font-bold text-[10px] md:text-xs uppercase transition-all border", {
      "bg-brand-500 text-white border-brand-500 shadow-lg": activeId === list.id,
      "bg-white dark:bg-slate-850 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-750 hover:text-slate-900 dark:hover:text-white": activeId !== list.id
    })}>{list.title.replace(/checklista zakupowa:/i, "")}</button>);
    $[6] = activeId;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <nav className="flex flex-wrap justify-center gap-1.5 mb-6 no-print">{t5}</nav>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== checkedItems || $[11] !== currentData) {
    t7 = <ChecklistCard data={currentData} checkedItems={checkedItems} onToggleItem={toggleItem} onPrint={handlePrint} />;
    $[10] = checkedItems;
    $[11] = currentData;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="max-w-4xl mx-auto px-2 py-4 md:py-12">{t3}{t4}{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp() {
  window.print();
}